// @flow

import { type RequestFetchCustomReceipts, useCustomReceiptsHandlerContext } from './context';

export function useRequestFetchCustomReceipts(): RequestFetchCustomReceipts {
  const customReceiptsContext = useCustomReceiptsHandlerContext();
  return customReceiptsContext.requestFetchCustomReceipts;
}
